import React from 'react'
import { Query } from '@apollo/client/react/components'
import { GET_OWN_INTAKE_QUERY } from '../../queries/GET_OWN_INTAKE_QUERY'
import { LIST_CONTENTS_QUERY } from '../../queries/LIST_CONTENTS_QUERY'
import { ListContentsQuery } from '../../schema/schemaTypes'
import { GetOwnIntakeQuery } from '../../schema/schemaTypes'
import { ContentsManager } from './ContentsManager'



// tslint:disable-next-line:no-var-requires
import myContentEnglish from './05_contents.json'
import myContentSpanish from './05_contents_es.json'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'


export const CmsContentsContainer = () => {
  (window as any).myContent = lang === 'es' ? myContentSpanish : myContentEnglish
  return (
    <Query<ListContentsQuery> query={LIST_CONTENTS_QUERY}>{({ data, loading, error }) => {
      if (loading) { return null }
      if (error || !data || !data.listContents) { location.reload() }
      const contents = data!.listContents!
      return (
        <Query<GetOwnIntakeQuery> query={GET_OWN_INTAKE_QUERY}>{({ data: data2, loading: loading2, error: error2 }) => {
          if (loading2) { return null }
          if (error2 || !data2 || !data2.getOwnIntake) { location.reload() }
          const intake = data2!.getOwnIntake!
          const pdfMapUri: (string | null) = data2!.me!.site!.pdfMapUri

          localStorage.setItem('pdfMapUri', pdfMapUri || '')

          return (
            <ContentsManager contents={contents} intake={intake} />
          )
        }}</Query>
      )
    }}</Query>
    )
}



// WEBPACK FOOTER //
// ./src/organisms/Contents/CmsContentsContainer.tsx